import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import toast from "react-hot-toast";
import { updateUser } from "../actions/user";
import { signOut } from "../Api/index";

export default function useLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return async () => {
    const user = JSON.parse(secureLocalStorage.getItem("profile") || "null");
    const loggingOutId = toast.loading("Logging you out...");
    dispatch(updateUser(user?.results?._id, { login: "no", system: "none" }));
    // Ends the shared login, so the other apps are logged out too
    await signOut().catch(() => {});
    dispatch({ type: "LOGOUT" });
    toast.success("You are logged out. See you again!", { id: loggingOutId });
    navigate("/insurance/login");
  };
}
